<template>
  <!-- Begin Page Content -->
  <div class="container-fluid">
    <div class="row justify-content-between">
      <div class="col">
        <h1 class="h3 mb-2 text-gray-800">Миний хичээлүүд</h1>
      </div>
    </div>
    <!-- DataTales Example -->
    <div v-for="school in schools" v-bind:key="school.id">
      <div class="card shadow my-4">
        <div class="card-header m-0">
          <h2>{{ school.currentYear }}</h2>
          <div class="d-flex justify-content-end">
            <button
              class="btn btn-sm btn-danger"
              @click="
                $router.push({
                  name: 'XAddLesson',
                  params: { schoolId: school.id, setTeacher: true },
                })
              "
            >
              Xичээл+
            </button>
          </div>
          <!-- <div class="col-auto"><router-link v-bind:to="'schools/'+school.id+'/lessonadd/'+school.id"> <div class="btn btn-success btn-sm">Хичээл нэмэх</div></router-link></div> -->
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <table
              class="table table-bordered"
              id="dataTable"
              width="100%"
              cellspacing="0"
              v-if="
                school.lessonsCurrentYear != null &&
                school.lessonsCurrentYear.length > 0
              "
            >
              <thead>
                <tr>
                  <th>№</th>
                  <th>Анги</th>
                  <th>Нэр</th>
                  <th>Зааx жил</th>
                  <th>Төрөл</th>
                  <th>Ангиар/Группээр</th>
                  <th>Нээлттэй эсэx</th>
                  <th>Үйлдэл</th>
                </tr>
              </thead>

              <tbody>
                <tr
                  v-for="(lesson, index) in school.lessonsCurrentYear"
                  v-bind:key="lesson.id"
                >
                  <td>{{ index + 1 }}</td>
                  <td>
                    <ul v-if="lesson.groups && lesson.groups.length > 0">
                      <li
                        class="text-primary"
                        style="cursor: pointer"
                        v-for="(group, index) in lesson.groups"
                        :key="index"
                        @click="
                          $router.push({
                            name: 'IGroupStudents',
                            params: {
                              schoolId: schoolId,
                              departmentId: group.department.id,
                              programId: group.program.id,
                            },
                          })
                        "
                      >
                        <span v-if="group.departmentName">{{
                          group.departmentName
                        }}</span>
                        <span v-else>-</span>

                        <span class="text-uppercase" v-if="group.programName">{{
                          group.programName
                        }}</span>
                        <span v-else>-</span>
                        <span v-if="index < lesson.groups.length - 1">, </span>
                      </li>
                    </ul>
                  </td>
                  <td>
                    <span
                      v-if="lesson.teacher.path != userProfile.customer.path"
                      ><i
                        class="fas fa-star text-danger"
                        :title="'Xамтарсан xичээл'"
                      ></i
                    ></span>
                    {{ lesson.name }}
                    <!-- {{lesson.deleted}} -->
                  </td>
                  <td>
                    {{ lesson.year }}
                  </td>
                  <td>
                    <span
                      class="badge badge-success"
                      v-if="lesson.lessonType != null && lesson.lessonType == 1"
                      > Заавал </span
                    >
                    <span class="badge badge-warning" v-else>
                       Сонгон </span
                    >
                  </td>
                  <td>
                    <span v-if="lesson.isGroup" class="badge badge-group"
                      >группээр</span
                    >
                    <span v-else class="badge badge-class">ангиар</span>
                  </td>

                  <td>
                    <h6 v-if="lesson.published == true">
                      <span class="badge badge-success">Нээлттэй</span>
                    </h6>
                    <h6 v-else style="cursor: pointer">
                      <span class="badge badge-danger">Хаалттай</span>
                    </h6>
                  </td>
                  <td>
                    <div class="row">
                      <!-- <button class="btn btn-danger btn-sm mx-1" @click="$router.push({name:'ILessonLog', params:{ schoolId: school.id, lessonId: lesson.id }})">ирц</button> -->
                      <button
                        class="btn btn-primary btn-sm mx-1"
                        @click="goDetail(lesson, school)"
                      >
                        харах
                      </button>
                      <button
                        class="btn btn-warning btn-sm mx-1"
                        @click="edit(lesson, school.id)"
                      >
                        засах
                      </button>
                      <!-- <button class="btn btn-danger btn-sm mx-1" @click="deleteLesson(lesson, semester)">устгах</button> -->
                      <!-- <div class="btn btn-danger btn-sm mx-1" @click="askCopyLesson(lesson)">Copy</div> -->
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div v-else class="alert alert-warning text-center">
              Та ямар нэгэн хичээл оруулаагүй байна.
            </div>
          </div>
        </div>
      </div>
      <div class="card shadow my-4">
        <div class="card-header m-0">
          <h5>Өмнөx жилийн xичээлүүд</h5>
          <!-- <div class="col-auto"><router-link v-bind:to="'schools/'+school.id+'/lessonadd/'+school.id"> <div class="btn btn-success btn-sm">Хичээл нэмэх</div></router-link></div> -->
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <table
              class="table table-bordered"
              id="dataTable"
              width="100%"
              cellspacing="0"
              v-if="school.lessons != null && school.lessons.length > 0"
            >
              <thead>
                <tr>
                  <th>№</th>
                  <th>Анги</th>
                  <th>Нэр</th>
                  <th>Зааx жил</th>
                  <th>Төрөл</th>
                  <th>Ангиар/Группээр</th>
                  <th>Нээлттэй эсэx</th>
                  <th>Үйлдэл</th>
                </tr>
              </thead>

              <tbody>
                <tr
                  v-for="(lesson, index) in school.lessons"
                  v-bind:key="lesson.id"
                >
                  <td>{{ index + 1 }}</td>
                  <td>
                    <ul v-if="lesson.groups && lesson.groups.length > 0">
                      <li
                        class="text-primary"
                        style="cursor: pointer"
                        v-for="(group, index) in lesson.groups"
                        :key="index"
                        @click="
                          $router.push({
                            name: 'IGroupStudents',
                            params: {
                              schoolId: schoolId,
                              departmentId: group.department.id,
                              programId: group.program.id,
                            },
                          })
                        "
                      >
                        <span v-if="group.departmentName">{{
                          group.departmentName
                        }}</span>
                        <span v-else>-</span>

                        <span class="text-uppercase" v-if="group.programName">{{
                          group.programName
                        }}</span>
                        <span v-else>-</span>
                        <span v-if="index < lesson.groups.length - 1">, </span>
                      </li>
                    </ul>
                  </td>
                  <td>
                    <span
                      v-if="lesson.teacher.path != userProfile.customer.path"
                      ><i
                        class="fas fa-star text-danger"
                        :title="'Xамтарсан xичээл'"
                      ></i
                    ></span>
                    {{ lesson.name }}
                    <!-- , {{lesson.id}}, {{lesson.deleted}} -->
                  </td>
                  <td>
                    {{ lesson.year }}
                  </td>
                  <td>
                    <span
                      class="badge badge-success"
                      v-if="lesson.categoryTypeId == 'zaaval'"
                      >{{ lesson.categoryTypeName }}</span
                    >
                    <span class="badge badge-warning" v-else>{{
                      lesson.categoryTypeName
                    }}</span>
                  </td>
                  <td>
                    <span v-if="lesson.isGroup" class="badge badge-group"
                      >группээр</span
                    >
                    <span v-else class="badge badge-class">ангиар</span>
                  </td>

                  <td>
                    <h6 v-if="lesson.published == true">
                      <span class="badge badge-success">Нээлттэй</span>
                    </h6>
                    <h6 v-else style="cursor: pointer">
                      <span class="badge badge-danger">Хаалттай</span>
                    </h6>
                  </td>
                  <td>
                    <div class="row">
                      <!-- <button class="btn btn-danger btn-sm mx-1" @click="$router.push({name:'ILessonLog', params:{ schoolId: school.id, lessonId: lesson.id }})">ирц</button> -->
                      <button
                        class="btn btn-primary btn-sm mx-1"
                        @click="goDetail(lesson, school)"
                      >
                        харах
                      </button>
                      <button
                        class="btn btn-warning btn-sm mx-1"
                        @click="edit(lesson, school.id)"
                      >
                        засах
                      </button>
                      <!-- <button class="btn btn-danger btn-sm mx-1" @click="deleteLesson(lesson, semester)">устгах</button> -->
                      <!-- <div class="btn btn-danger btn-sm mx-1" @click="askCopyLesson(lesson)">Copy</div> -->
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div v-else class="alert alert-warning text-center">
              Та ямар нэгэн хичээл оруулаагүй байна.
            </div>
          </div>
        </div>

        <div
          class="card-body"
          v-if="school.sharedlessons != null && school.sharedlessons.length > 0"
        >
          <h3>Орлож заах хичээл</h3>
          <div class="table-responsive">
            <table
              class="table table-bordered"
              id="dataTable"
              width="100%"
              cellspacing="0"
            >
              <thead>
                <tr>
                  <th>№</th>
                  <th>Анги</th>
                  <th>Нэр</th>
                  <td>Багш</td>
                  <th>Төлөв</th>
                  <th>Үйлдэл</th>
                </tr>
              </thead>

              <tbody>
                <tr
                  v-for="(lesson, index) in school.sharedlessons"
                  :key="index"
                >
                  <td>{{ index + 1 }}</td>
                  <td>
                    <ul v-if="lesson.groups && lesson.groups.length > 0">
                      <li
                        style="cursor: pointer"
                        v-for="(group, index) in lesson.groups"
                        :key="index"
                        @click="
                          $router.push({
                            name: 'IGroupStudents',
                            params: {
                              schoolId: schoolId,
                              departmentId: group.department.id,
                              programId: group.program.id,
                            },
                          })
                        "
                      >
                        <span
                          class="text-primary"
                          v-if="group.departmentName"
                          >{{ group.departmentName }}</span
                        >
                        <span v-else>-</span>
                        <span class="text-primary" v-if="group.programName">{{
                          group.programName
                        }}</span>
                        <span v-else>-</span>
                        <span v-if="index < lesson.groups.length - 1">, </span>
                        <!-- <span v-else></span> -->
                      </li>
                    </ul>
                  </td>
                  <td>{{ lesson.name }}</td>
                  <td>
                    <div
                      style="cursor: pointer"
                      v-if="lesson.teachers && lesson.teachers.length > 0"
                      @click="
                        $router.push({
                          name: 'TeacherLessons',
                          params: {
                            schoolId: schoolId,
                            teacherPath: lesson.teachers[0].reference.path,
                          },
                        })
                      "
                    >
                      <span v-if="lesson.teachers">
                        {{ lesson.teachers[0].firstName }}
                      </span>

                      <span v-if="lesson.teachers">
                        / {{ lesson.teachers[0].lastName }}
                      </span>
                    </div>
                  </td>

                  <td>
                    <h6 v-if="lesson.published == true" style="cursor: pointer">
                      <span class="badge badge-success">Нээлттэй</span>
                    </h6>
                    <h6 v-else style="cursor: pointer">
                      <span class="badge badge-danger">Хаалттай</span>
                    </h6>
                  </td>
                  <td>
                    <div class="row">
                      <button
                        class="btn btn-primary btn-sm mx-1"
                        @click="
                          $router.push({
                            name: 'ILessonLog',
                            params: {
                              schoolId: school.id,
                              lessonId: lesson.id,
                            },
                          })
                        "
                      >
                        харах
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div
      class="modal fade"
      id="copyModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="copyModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="qaModalLabel">Хичээл хуулах</h5>

            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" v-if="copyLesson != null">
            <h3>
              Та {{ copyLesson.name }} хичээлийг хуулах уу? Хэрэв хуулах бол
              доорх хичээлийн улирлуудаас сонгоно уу
            </h3>
            <div class="row">
              <div class="col form-group">
                <label for="exampleFormControlSelect1">Улирал:</label>
                <select class="form-control" v-model="copySemester">
                  <option
                    v-for="semester in semesters"
                    v-bind:key="'semester-' + semester.id"
                    v-bind:value="semester.id"
                  >
                    {{ semester.title }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Болих
            </button>
            <button
              @click="doCopy"
              type="button"
              class="btn btn-primary btn-user btn-block"
            >
              Хуулах
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /.container-fluid -->
</template>

<script>
const fb = require("../firebaseConfig.js");
import Vue from "vue";
import { mapState } from "vuex";
import { currentUser } from "../firebaseConfig.js";
import moment from "moment";
// import myfunction from 'global/myfunction.js';
// import VueResource from 'vue-resource';
// Vue.use(VueResource);
export default {
  name: "HelloWorld",
  data() {
    return {
      msg: "Hellow",
      lessons: [],
      trending: {
        content: [],
      },
      semesters: [],
      copyLesson: null,
      copySemester: null,
      schools: [],
      userObject: null, // customer
    };
  },
  computed: {
    ...mapState(["currentUser", "userProfile"]),
  },
  created() {
    this.readSchool();
  },

  methods: {
    async _addLesson() {
      console.log("xxxx");
    },
    async _findCategory(schoolId, lesson) {
      var catRef = await fb.db
        .collection("schools/" + schoolId + "/categories")
        .doc(lesson.category.id)
        .get();
      if (catRef.exists) {
        lesson.categoryTypeId = catRef.data().typeDetail.id;
        lesson.categoryTypeName = catRef.data().typeDetail.name;
      }
    },
    async getLessonsData(school) {
      school.lessons = null;
      school.lessonsCurrentYear = null;
      school.joinedLessons = [];
      fb.db
        .collection("schools/" + school.id + "/lessons")
        .where("teacherRefs", "array-contains", this.userProfile.customer)
        .onSnapshot((docs) => {
          school.lessons = [];
          school.lessonsCurrentYear = [];
          docs.forEach(async (doc) => {
            let lesson = doc.data();
            lesson.id = doc.id;
            lesson.ref = doc.ref;
            lesson.procent = 0;

            if (
              lesson.category &&
              lesson.category.id &&
              lesson.lessonType == undefined
            ) {
              fb.db
                .doc(lesson.category.path)
                .get()
                .then((doc) => {
                  if (
                    doc.data().typeDetail != null &&
                    doc.data().typeDetail != undefined
                  ) {
                    if (doc.data().typeDetail.id == "zaaval")
                      lesson.ref.update({ lessonType: 1 });
                    else lesson.ref.update({ lessonType: 0 });
                  }
                });
            }
            if (
              lesson.year != undefined &&
              lesson.year != null &&
              lesson.year == school.currentYear
            ) {
              if (lesson.deleted == true) {
              } else school.lessonsCurrentYear.push(lesson);
            } else {
              if (lesson.deleted == true) {
              } else school.lessons.push(lesson);
            }
          });
        });

      this.loading = false;
    },

    async _getLessons() {
      var _this = this;
      var vm = this;
      for (const school of this.schools) {
        if (school) {
          await this.getLessonsData(school);

          fb.db
            .collection("schools")
            .doc(school.id)
            .collection("lessons")
            .where(
              "sharedTeachers",
              "array-contains",
              this.userProfile.customer
            )
            .onSnapshot((querySnapshot) => {
              if (!querySnapshot.empty) {
                school.sharedlessons = [];
                querySnapshot.forEach((lessonDoc) => {
                  let lesson = lessonDoc.data();
                  lesson.id = lessonDoc.id;
                  lesson.path = lessonDoc.ref.path;
                  school.sharedlessons.push(lesson);
                });
              }
            });
        }
      }
    },
    askCopyLesson(lesson) {
      var r = confirm(
        "Та " + lesson.name + " хичээлийг хуулахдаа итгэлтэй байна уу!!!"
      );
      if (r == true) {
        this.copyLesson = lesson;
        $("#copyModal").modal("show");
      }
    },
    async doCopy(lesson) {
      if (
        this.copyLesson != null &&
        this.copySemester != null &&
        this.copySemester != ""
      ) {
        var copyLessonRef = await fb.db.collection("lessons").doc();
        var tmpLesson = Object.assign({}, this.copyLesson);
        delete tmpLesson.id;
        tmpLesson.createdAt = new Date();
        tmpLesson.lectureCode = new Date().getTime();
        tmpLesson.copiedFrom = fb.db
          .collection("lessons")
          .doc(this.copyLesson.id);
        tmpLesson.semester = fb.db
          .collection("semester")
          .doc(this.copySemester);
        tmpLesson.copiedAt = new Date();
        tmpLesson.published = false;

        copyLessonRef.set(tmpLesson);

        var topicDocs = await fb.db
          .collection("lessons/" + this.copyLesson.id + "/topics")
          .orderBy("createdAt")
          .get();

        for (const topic of topicDocs.docs) {
          console.log(topic);
          var tmpTopic = topic.data();
          var copyTopicRef = copyLessonRef.collection("topics").doc();
          copyTopicRef.set(tmpTopic);

          var detailDocs = await fb.db
            .collection(
              "lessons/" +
                this.copyLesson.id +
                "/topics/" +
                topic.id +
                "/details"
            )
            .orderBy("createdAt")
            .get();

          for (const detail of detailDocs.docs) {
            var tmpdetail = detail.data();
            copyTopicRef.collection("details").doc().set(tmpdetail);
          }
        }

        this.copyLesson = null;
        this.copySemester = null;
        $("#copyModal").modal("hide");
      } else {
        alert("Та хуулах хичээл болон улиралаа заавал сонгоно уу");
      }
    },

    goDetail(lesson, school) {
      this.$router.push({
        name: "XILessonDetail",
        params: { schoolId: school.id, lessonId: lesson.id },
      });
    },
    edit(lesson, sId) {
      if (sId && sId != "")
        this.$router.push({
          name: "ILessonEdit",
          params: { lessonId: lesson.id, schoolId: sId },
        });
      else
        this.$router.push({
          name: "LessonEdit",
          params: { lessonId: lesson.id },
        });
    },
    deleteLesson(lesson, cat) {
      var r = confirm(
        "Та " + lesson.name + " хичээлийг устгахдаа итгэлтэй байна уу."
      );
      if (r == true) {
        if (
          cat != null &&
          lesson != null &&
          cat.id != null &&
          lesson.id != null
        ) {
          fb.db.collection("lessons").doc(lesson.id).delete();
        }
      }
    },
    async readSchool() {
      if (
        this.userProfile != null &&
        this.userProfile["role"] != null &&
        this.userProfile["role"] == "admin"
      ) {
        var querySnapshot = await fb.db.collection("schools").get();

        querySnapshot.forEach((schoolData) => {
          let school = schoolData.data();
          school.id = schoolData.id;
          school.ref = schoolData.ref;
          school.lessons = [];
          school.sharedlessons = [];
          this.schools.push(school);
        });
      } else if (
        this.userProfile != null &&
        this.userProfile["role"] != null &&
        this.userProfile["customer"] != null &&
        (this.userProfile["role"] == "sts" ||
          this.userProfile["role"] == "manager")
      ) {
        var cusDoc = await this.userProfile["customer"].get();
        if (
          cusDoc.exists &&
          cusDoc.data().schools != null &&
          cusDoc.data().schools != undefined &&
          cusDoc.data().schools.length > 0
        ) {
          for (const scRef of cusDoc.data().schools) {
            var schoolData = await scRef.get();
            let school = schoolData.data();
            school.id = schoolData.id;
            school.ref = schoolData.ref;
            school.lessons = [];
            school.sharedlessons = [];
            this.schools.push(school);
          }
          this.userObject = cusDoc;
        }
      } else if (
        this.userProfile != null &&
        this.userProfile["role"] != null &&
        this.userProfile["customer"] != null &&
        this.userProfile["role"] == "teacher"
      ) {
        var cusDoc = await this.userProfile["customer"].get();
        if (
          cusDoc.exists &&
          cusDoc.data().school != null &&
          cusDoc.data().school != undefined
        ) {
          var schoolData = await cusDoc.data().school.get();
          let school = schoolData.data();
          school.id = schoolData.id;
          school.ref = schoolData.ref;
          school.lessons = [];
          school.sharedlessons = [];

          this.schools.push(school);
          this.userObject = cusDoc;
        }
      }
      await this._getLessons();
    },
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).fromNow();
    },
  },
};
</script>